import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "sort" })
export class SortPipe implements PipeTransform {
  transform(value: { Order: number }[], sortBy?: string): any[] {
    if (value == null || value.length == 0) {
      return [];
    }
    if (sortBy && sortBy != "" && value[0][sortBy]) {
      return value.sort((a, b) => a[sortBy].Order - b[sortBy].Order);
    } else {
      return value.sort((a, b) => a.Order - b.Order);
    }
  }
}
